import { StandardPlan } from "assets/icons";
import "./style.scss";
import Button from "components/BaseWidgets/button";
import Tag from "components/BaseWidgets/tag";
import { priceFormatPrice } from "utils/formatHelper";

function MiniPlanCard({
  data: { title, tagText, offerPrice, oldPrice, planValidity, views },
  onOk,
  isLoading,
  isPopular,
}) {
  return (
    <div className={`mini-plan-card ${isPopular ? "popular-card" : ""}`}>
      <span className="plan-icon">
        <StandardPlan />
      </span>
      <div className="flex flex-col gap-2 items-center">
        <Tag readOnly className="plan-yellow-tag" variant="yellow">
          {tagText}
        </Tag>
        <span className="mt-2 font-title-lg fw-700 leading-3 title">
          {title}
        </span>

        <div className="flex flex-col items-center gap-1">
          <span className="flex items-end font-title-xs fw-700 leading-1 text-gray flex-wrap">
            <span className="ml-3 text-gray">
              {priceFormatPrice(offerPrice)}
            </span>
            <span className="ml-2 font-body-normal fw-400 leading-1 text-gray line-through">
              {priceFormatPrice(oldPrice)}
            </span>
          </span>
          <span className="text-gray font-body-normal leading-1 flex-wrap">
            Plan validity for
            <span className="ml-2 text-gray">{planValidity} days</span>
          </span>
          <span className="text-gray font-body-normal leading-1 flex-wrap">
            Contact views
            <span className="ml-2 text-gray">{views}</span>
          </span>
        </div>
      </div>
      <Button
        isLoading={isLoading}
        onClick={onOk}
        wFull
        height={44}
        className="join-btn"
      >
        Join now
      </Button>
    </div>
  );
}

export default MiniPlanCard;
